module.exports = __webpack_public_path__ + "img/concept-art-part-1.980ab0aa.png";